<script>
import {
  CdrText,
  CdrAccordionGroup,
  CdrAccordion,
} from '@rei/cedar';
import analytics from '../../common/analytics';

export default {
  name: 'GiftcardFaqComponent',
  components: {
    CdrText,
    CdrAccordionGroup,
    CdrAccordion,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    faqData: {
      type: Array,
      required: true,
    },
    siteId: {
      type: String,
      required: true,
    },
    pageDescription: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      accordions: this.faqData,
    };
  },
  computed: {
    validProps() {
      return this.title && (typeof this.faqData !== 'undefined');
    },
  },
  methods: {
    toggleAccordion(idx) {
      this.accordions[idx].opened = !this.accordions[idx].opened;
      analytics.click({ linkName: `${this.siteId}:${this.pageDescription}_${this.faqData[idx].question}` });
    },
  },
};
</script>

<template>
  <div
    v-if="validProps"
    class="container giftcard-faq__section container-static"
    data-ui="faq-content"
  >
    <cdr-text
      class="giftcard-faq__title"
      tag="h3"
      data-ui="gift-card-faq-title"
    >
      {{ title }}
    </cdr-text>
    <cdr-accordion-group
      class="giftcard-faq__container"
      data-ui="gift-card-faq-accordion"
    >
      <cdr-accordion
        v-for="(faq, idx) in faqData"
        :id="faq.id"
        :key="faq.id"
        level="4"
        :opened="faq.opened"
        :data-ui="`gift-card-faq-list-${faq.id}`"
        @accordionToggle="toggleAccordion(idx)"
      >
        <template
          #label
        >
          {{ faq.question }}
        </template>
        <div
          class="giftcard-faq__answer"
          data-ui-analytic="link"
          v-html="faq.answer"
        />
      </cdr-accordion>
    </cdr-accordion-group>
  </div>
</template>
